import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function Section({ num, title, children, testid }) {
  return (
    <section data-testid={testid} className="border-t border-stone-800 py-10">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        <div className="md:col-span-2">
          <span className="outline-number font-display text-5xl font-light">{num}</span>
        </div>
        <div className="md:col-span-10">
          <h2 className="font-display text-xl font-medium text-amber-200/90 sm:text-2xl">{title}</h2>
          <div className="mt-4 space-y-3 text-sm leading-relaxed text-stone-400">{children}</div>
        </div>
      </div>
    </section>
  );
}

export default function ConfidentialitePage() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#0B0B0D] text-[#F5F3EF]">
      <header className="border-b border-[#D4AF37]/10 bg-[#0B0B0D]/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" data-testid="privacy-brand-link" className="font-display text-xl text-[#F5F3EF]">
            Valeur <span className="italic text-[#D4AF37]">Prestige</span>
          </Link>
          <Link to="/" data-testid="privacy-back-link" className="btn-ghost !px-4 !py-2 !text-xs">
            <ArrowLeft size={14} /> Retour au site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-16">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">Mentions légales & confidentialité</p>
        <h1 className="font-display mt-4 text-3xl font-light text-amber-100 sm:text-4xl">
          Vos données, traitées avec la même <em className="text-[#D4AF37]">exigence</em> que votre bien.
        </h1>
        <p className="mt-4 text-sm text-stone-500">Dernière mise à jour : septembre 2026</p>

        <div className="mt-10">
          <Section num="01" title="Éditeur du site" testid="privacy-editeur">
            <p>
              Barsamia Tumba, conseiller en immobilier (agent commercial), spécialisé dans la vente
              de biens de prestige à Montmartre Ouest (Paris 18e) et en Île-de-France.
            </p>
            <p>
              Carte professionnelle de transaction n° <span className="text-stone-200">CPI 75012015000002592</span>,
              délivrée par la Préfecture de Paris.
            </p>
            <p>
              Contact : <a href="tel:+33652592411" className="text-[#E5C158] hover:text-amber-200">+33 6 52 59 24 11</a>
              {" "}· <a href="mailto:barsamia.tumba@engelvoelkers.com" className="text-[#E5C158] hover:text-amber-200">barsamia.tumba@engelvoelkers.com</a>
            </p>
          </Section>

          <Section num="02" title="Données collectées" testid="privacy-donnees">
            <p>Dans le cadre du questionnaire d'estimation, les informations suivantes sont recueillies :</p>
            <ul className="list-disc space-y-1 pl-5">
              <li>Identité : prénom et nom ;</li>
              <li>Coordonnées : numéro de téléphone et adresse email ;</li>
              <li>Informations sur le bien : adresse (rue, code postal, ville), type, surface, nombre de pièces, étage, DPE, état général et calendrier de votre projet de vente.</li>
            </ul>
            <p>Aucune donnée bancaire ni document d'identité n'est demandé sur ce site.</p>
          </Section>

          <Section num="03" title="Finalités & base légale" testid="privacy-finalites">
            <p>Vos données sont utilisées exclusivement pour :</p>
            <ul className="list-disc space-y-1 pl-5">
              <li>établir votre estimation et vous la transmettre (mesures précontractuelles, art. 6.1.b du RGPD) ;</li>
              <li>vous recontacter au sujet de votre projet de vente, uniquement avec votre accord explicite (consentement, art. 6.1.a du RGPD).</li>
            </ul>
            <p>
              Vos données ne sont <span className="text-stone-200">jamais cédées, vendues ni louées</span> à des tiers.
              Elles sont destinées uniquement à Barsamia Tumba.
            </p>
          </Section>

          <Section num="04" title="Durée de conservation" testid="privacy-duree">
            <p>
              Vos données sont conservées pendant une durée maximale de <span className="text-stone-200">3 ans</span> à
              compter de votre dernière demande ou de notre dernier échange, puis supprimées.
            </p>
          </Section>

          <Section num="05" title="Vos droits" testid="privacy-droits">
            <p>
              Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits d'accès, de
              rectification, d'effacement, d'opposition, de limitation et de portabilité de vos données, ainsi que
              du droit de retirer votre consentement au recontact à tout moment.
            </p>
            <p>
              Pour exercer ces droits : <a href="mailto:barsamia.tumba@engelvoelkers.com" className="text-[#E5C158] hover:text-amber-200">barsamia.tumba@engelvoelkers.com</a>.
              Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).
            </p>
          </Section>

          <Section num="06" title="Cookies & sécurité" testid="privacy-cookies">
            <p>
              Ce site n'utilise aucun cookie publicitaire ni traceur tiers. Seuls des cookies techniques
              strictement nécessaires à son fonctionnement sont employés.
            </p>
            <p>
              Les données sont hébergées sur une infrastructure cloud sécurisée et transmises de manière chiffrée (HTTPS).
              L'accès à l'espace conseiller est protégé par authentification.
            </p>
          </Section>
        </div>
      </main>
    </div>
  );
}
